import { render, staticRenderFns } from "./WorkflowTransform.vue?vue&type=template&id=66ced5d2&"
import script from "./WorkflowTransform.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTransform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports